
































import Vue from 'vue';
import { Colour, createGame, createPlay, Game } from '@/game/model';
import GameBoard from '@/components/GameBoard.vue';
import Tray from '@/components/Tray.vue';
import Goal from '@/components/Goal.vue';
import { isGameLost, isGameWon, scoreGuess } from '@/game/scoring';

export default Vue.extend({
  name: 'ColourLogic',
  components: {
    Goal,
    GameBoard,
    Tray
  },
  data() {
    return {
      game: createGame()
    };
  },
  computed: {
    canSubmitGuess() {
      const game = this.$data.game as Game;
      return game.plays[game.plays.length - 1].guess.filter((colour) => !!colour).length === 4;
    }
  },
  methods: {
    startNewGame() {
      this.$data.game = createGame();
    },
    playPiece(colour: Colour) {
      const game = this.$data.game as Game;
      if (isGameLost(game) || isGameWon(game)) {
        return;
      }
      const currentPlay = game.plays[game.plays.length - 1];
      const index = currentPlay.guess.findIndex((colour: Colour) => colour === undefined);
      if (index >= 0) {
        console.log(`Playing ${colour} at position ${index}`);
        currentPlay.guess.splice(index, 1, colour);
      }
    },
    removePiece(index: number) {
      const game = this.$data.game as Game;
      const currentPlay = game.plays[game.plays.length - 1];
      if (currentPlay.guess[index] !== undefined) {
        console.log(`Removing piece at position ${index}`);
        currentPlay.guess.splice(index, 1, undefined);
      }
    },
    submitGuess() {
      console.log('submitGuess');
      const game = this.$data.game as Game;
      const score = scoreGuess(game.plays[game.plays.length - 1].guess, game.goal);
      console.log(`score = ${score}`);
      game.plays[game.plays.length - 1] = { ...game.plays[game.plays.length - 1], score };
      console.log(`#plays = ${game.plays.length}`);
      // if (game.plays.length < 10) {
        console.log('pushing');
        game.plays.push(createPlay());
        console.log('pushed');
      // }
      console.log('submitGuess done');
    },
    giveUp() {
      this.$data.game.quit = true;
    }
  }
});
